// import { useEffect, useState } from "react";
// import Swal from "sweetalert2";

// const AddPayModel = ({ item, onUpNow }) => {
//     const [formData, setFormData] = useState({
//         id: "",
//         lab_total: "",
//         lab_dis_per: "",
//         lab_fix_deposit: "",
//         lab_final_amt: "",
//         lab_paid: "",
//         lab_due: "",
//         alertMsgTyp: '',
//         isAlert: false,
//     });
//     const [additionalPayment, setAdditionalPayment] = useState(""); // New state for additional payment

//     useEffect(() => {
//         try {
//             if (formData.lab_total !== "" && !isNaN(parseFloat(formData.lab_total))) {
//                 let gtotal = parseFloat(formData.lab_total) || 0;
                
//                 if (formData.lab_dis_per !== "" && !isNaN(parseFloat(formData.lab_dis_per))) {
//                     const dis = parseFloat(formData.lab_dis_per);
//                     gtotal -= (gtotal * dis) / 100;
//                 }

//                 if (formData.lab_fix_deposit !== "" && !isNaN(parseFloat(formData.lab_fix_deposit))) {
//                     const fix_dep = parseFloat(formData.lab_fix_deposit);
//                     gtotal -= fix_dep;
//                 }

//                 // Fix to display 2 decimal places consistently
//                 const finalStr = isNaN(gtotal) ? "" : gtotal.toFixed(2);

//                 setFormData(prev => ({
//                     ...prev,
//                     lab_final_amt: finalStr
//                 }));

//                 if (formData.lab_paid !== "" && !isNaN(parseFloat(formData.lab_paid))) {
//                     const paid = parseFloat(formData.lab_paid) || 0;
//                     const due = gtotal - paid;
//                     setFormData(prev => ({
//                         ...prev,
//                         lab_due: isNaN(due) ? "" : due.toFixed(2)
//                     }));
//                 } else {
//                     setFormData(prev => ({ ...prev, lab_due: isNaN(gtotal) ? "" : gtotal.toFixed(2) }));
//                 }
//             }
//         } catch (error) {
//             // Silent
//             console.error("calc error", error);
//         }
//     }, [formData.lab_total, formData.lab_dis_per, formData.lab_fix_deposit, formData.lab_paid]);

//     useEffect(() => {
//         if (item) {
//             setFormData(prev => ({
//                 ...prev,
//                 id: item.lab_reg_id || "",
//                 lab_total: item.lab_total || "",
//                 lab_dis_per: item.lab_dis_per || "",
//                 lab_fix_deposit: item.lab_fix_deposit || "",
//                 lab_final_amt: item.lab_final_amt || "",
//                 lab_paid: item.lab_paid || "",
//                 lab_due: item.lab_due || ""
//             }));
//             setAdditionalPayment(""); // Reset additional payment when item changes
//         }
//     }, [item]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleAdditionalPaymentChange = (e) => {
//         const value = e.target.value;
//         // Allow only numbers and empty string (with optional decimal)
//         if (value === '' || /^\d*\.?\d*$/.test(value)) {
//             setAdditionalPayment(value);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
        
//         // Validate additional payment
//         const due = parseFloat(formData.lab_due) || 0;
//         const additional = parseFloat(additionalPayment) || 0;
        
//         if (additional > due) {
//             await Swal.fire({
//                 icon: "error",
//                 title: "Invalid amount",
//                 text: "Additional payment cannot exceed due amount",
//             });
//             return;
//         }

//         if (additional < 0) {
//             await Swal.fire({
//                 icon: "error",
//                 title: "Invalid amount",
//                 text: "Payment amount cannot be negative",
//             });
//             return;
//         }

//         // Calculate new paid amount and due
//         const newPaid = (parseFloat(formData.lab_paid) || 0) + additional;
//         const newDue = due - additional;

//         try {
//             // onUpNow may be async; await if it returns a Promise
//             const res = onUpNow(
//                 formData.id,
//                 formData.lab_total,
//                 formData.lab_dis_per,
//                 formData.lab_fix_deposit,
//                 formData.lab_final_amt,
//                 newPaid.toString(),
//                 newDue.toString()
//             );

//             // Await if Promise-like
//             if (res && typeof res.then === "function") {
//                 await res;
//             }

//             // Success Alert
//             await Swal.fire({
//                 icon: "success",
//                 title: "Payment Updated",
//                 text: `Payment of ${additional.toFixed(2)} applied successfully.`,
//                 timer: 1600,
//                 showConfirmButton: false
//             });

//             // Close modal by triggering close button if exists
//             const closeBtn = document.getElementById("close-modal");
//             if (closeBtn) closeBtn.click();

//             // Optionally, you may trigger a refresh or let parent update UI.
//             // If you still want to reload page uncomment next line:
//             // window.location.reload();

//         } catch (error) {
//             console.error("onUpNow error:", error);
//             await Swal.fire({
//                 icon: "error",
//                 title: "Update failed",
//                 text: error?.message || "Server error while updating payment. Please try again.",
//             });
//         }
//     };

//     return (
//         <div className="modal fade" id="showModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
//             <div className="modal-dialog modal-dialog-centered">
//                 <div className="modal-content">
//                     <div className="modal-header bg-light p-3">
//                         <h5 className="modal-title" id="exampleModalLabel">&nbsp;</h5>
//                         <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
//                     </div>
//                     <form className="tablelist-form" onSubmit={handleSubmit}>
//                         <div className="modal-body">
//                             <input id="id-field" type="hidden" />
//                             <div className="row gy-4 mb-3">
//                                 <div className="col-md-6">
//                                     <div className="mb-3">
//                                         <label className="form-label">Total Amount</label>
//                                         <input type="number" className="form-control"
//                                             name="lab_total" onChange={handleChange} 
//                                             value={formData.lab_total} required readOnly />
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <div className="mb-3">
//                                         <label className="form-label">Discount(%)</label>
//                                         <input type="number" className="form-control" placeholder="Enter Discount"
//                                             name="lab_dis_per" onChange={handleChange} 
//                                             value={formData.lab_dis_per} required />
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <div className="mb-3">
//                                         <label className="form-label">Fixed Deposit</label>
//                                         <input type="number" className="form-control" placeholder="Enter Fixed Deposit"
//                                             name="lab_fix_deposit" onChange={handleChange} 
//                                             value={formData.lab_fix_deposit} required />
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <div className="mb-3">
//                                         <label className="form-label">Final Amount</label>
//                                         <input type="number" className="form-control"
//                                             name="lab_final_amt" 
//                                             value={formData.lab_final_amt} readOnly />
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <div className="mb-3">
//                                         <label className="form-label">Paid So Far</label>
//                                         <input type="number" className="form-control"
//                                             name="lab_paid" 
//                                             value={formData.lab_paid} readOnly />
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <div className="mb-3">
//                                         <label className="form-label">Due</label>
//                                         <input type="text" className="form-control"
//                                             name="lab_due" 
//                                             value={formData.lab_due} readOnly />
//                                     </div>
//                                 </div>
                                
//                                 {/* New Additional Payment Input */}
//                                 {parseFloat(formData.lab_due) > 0 && (
//                                     <div className="col-md-12">
//                                         <div className="mb-3">
//                                             <label className="form-label">
//                                                 Pay Due (Max: {formData.lab_due})
//                                             </label>
//                                             <input 
//                                                 type="number"
//                                                 className="form-control"
//                                                 placeholder="Enter payment amount"
//                                                 value={additionalPayment}
//                                                 onChange={handleAdditionalPaymentChange}
//                                                 min="0"
//                                                 max={formData.lab_due}
//                                                 step="0.01"
//                                             />
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                         <div className="modal-footer">
//                             <div className="hstack gap-2 justify-content-end">
//                                 <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>
//                                 <button type="submit" className="btn btn-success" id="edit-btn">Pay</button>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default AddPayModel;
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

const AddPayModel = ({ item, onUpNow }) => {
  const [formData, setFormData] = useState({
    id: "",
    lab_total: "",
    lab_dis_per: "",
    lab_fix_deposit: "",
    lab_final_amt: "",
    lab_paid: "",
    lab_due: ""
  });
  const [additionalPayment, setAdditionalPayment] = useState("");
  const [payMode, setPayMode] = useState("Cash"); // new: pay mode (Cash/Card/Online)
  //const [duePayMode, setDuePayMode] = useState("Cash"); // optional separate column for due-mode if needed

  useEffect(() => {
    if (item) {
      setFormData({
        id: item.lab_reg_id || "",
        lab_total: item.lab_total || "",
        lab_dis_per: item.lab_dis_per || "",
        lab_fix_deposit: item.lab_fix_deposit || "",
        lab_final_amt: item.lab_final_amt || "",
        lab_paid: item.lab_paid || "",
        lab_due: item.lab_due || ""
      });
      setAdditionalPayment("");
      // preselect pay mode if item has it
      setPayMode(item.lab_due_pay_mode || "Cash");
      //setDuePayMode(item.lab_due_pay_mode || "");
    }
  }, [item]);

  const handleAdditionalPaymentChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) setAdditionalPayment(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const due = parseFloat(formData.lab_due) || 0;
    const additional = parseFloat(additionalPayment) || 0;

    if (additional > due) {
      await Swal.fire({ icon: "error", title: "Invalid amount", text: "Additional payment cannot exceed due amount" });
      return;
    }
    if (additional < 0) {
      await Swal.fire({ icon: "error", title: "Invalid amount", text: "Payment amount cannot be negative" });
      return;
    }

    // new paid and due
    const newPaid = (parseFloat(formData.lab_paid) || 0) + additional;
    const newDue = due - additional;

    try {
      // pass payMode and duePayMode to parent handler
      // before calling onUpNow — debug log
console.log("Submitting payment", {
    id: formData.id,
    newPaid: newPaid.toString(),
    newDue: newDue.toString(),
    lab_due_pay_mode: payMode
  });
  
  const res = onUpNow(
    formData.id,
    formData.lab_total,
    formData.lab_dis_per,
    formData.lab_fix_deposit,
    formData.lab_final_amt,
    newPaid.toString(),
    newDue.toString(),
    "",        // lab_pay_mode (leave blank so original lab_pay_mode isn't overwritten)
    payMode    // lab_due_pay_mode  <- important: send selected pay mode here
  );
  
      

      if (res && typeof res.then === "function") await res;

      await Swal.fire({ icon: "success", title: "Payment Updated", text: `Payment of ${additional.toFixed(2)} applied`, timer: 1400, showConfirmButton: false });

      // close modal
      document.getElementById("close-modal")?.click();
    } catch (err) {
      console.error("onUpNow error:", err);
      await Swal.fire({ icon: "error", title: "Update failed", text: err?.message || "Server error" });
    }
  };

  return (
    <div className="modal fade" id="showModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title">&nbsp;</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row gy-4 mb-3">
                {/* ... existing fields (Total, Discount, etc.) ... */}
                <div className="col-md-6">
                  <label className="form-label">Total Amount</label>
                  <input className="form-control" type="number" name="lab_total" value={formData.lab_total} readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Discount(%)</label>
                  <input className="form-control" type="number" name="lab_dis_per" value={formData.lab_dis_per} readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Final Amount</label>
                  <input className="form-control" type="number" name="lab_final_amt" value={formData.lab_final_amt} readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Paid So Far</label>
                  <input className="form-control" type="number" name="lab_paid" value={formData.lab_paid} readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Due</label>
                  <input className="form-control" type="text" name="lab_due" value={formData.lab_due} readOnly />
                </div>

                {/* New payment input */}
                {parseFloat(formData.lab_due) > 0 && (
                  <div className="col-md-6">
                    <label className="form-label">Pay Due (Max: {formData.lab_due})</label>
                    <input className="form-control" type="number" value={additionalPayment} onChange={handleAdditionalPaymentChange} step="0.01" min="0" max={formData.lab_due} />
                  </div>
                )}

                {/* New: Pay Mode selector */}
                <div className="col-md-12">
                  <label className="form-label">Pay Mode</label>
                  <select className="form-control" value={payMode} onChange={(e) => setPayMode(e.target.value)}>
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Online">Online</option>
                  </select>
                </div>

                {/* Optional: separate due-pay-mode column */}
                
              </div>
            </div>

            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                <button type="submit" className="btn btn-success">Pay</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPayModel;
